import ListingInformation from './ListingInformation.component';

export default ListingInformation;
